import { View, StyleSheet, Text, Pressable } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import ModalContainer from "@/ui/ModalContainer";
import { ms } from "@/ui/moderateScale";
import { useTranslation } from "react-i18next";
import { Colors } from "@/constants";
import Icon from "./Icon";
import { useUserSlice } from "@/models/useUserSlice";

const AlertWidgetManageFolders = () => {
  const visible = useUISlice((state) => state.alertWidget === "manageFolders");
  const setVisible = useUISlice((state) => state.setAlertWidget);
  const folders = useUserSlice((state) => state.folders);
  const width = useUISlice((state) => state.device.width);
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <ModalContainer
      shouldPersistBackdropClick
      title={t("alertWidgetManageFolders.title")}
      onDismiss={() => setVisible(undefined)}
      hideCancel
      modalWidth={Math.min(width, 600)}
    >
      <View style={styles.spacer} />

      {folders.map((folder) => (
        <View key={folder.id} style={styles.buttonContainer}>
          <View style={styles.folderContainer}>
            <Icon icon="folder" />
            <Text numberOfLines={1} style={styles.buttonText}>
              {folder.name}
            </Text>
          </View>

          <View style={styles.actionsContainer}>
            <Pressable
              onPress={() => useUserSlice.getState().folder().rename(folder.id)}
              style={styles.editButton}
            >
              <Icon icon="pen" style={styles.whiteIcon} />
            </Pressable>

            <Pressable
              onPress={() => useUserSlice.getState().folder().delete(folder.id)}
              style={styles.deleteButton}
            >
              <Icon icon="bin" style={styles.whiteIcon} />
            </Pressable>
          </View>
        </View>
      ))}
      <View style={styles.negativeMargin} />
    </ModalContainer>
  );
};

const styles = StyleSheet.create({
  spacer: {
    height: ms(16),
  },
  largerSpacer: {
    height: ms(48),
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: ms(8),
    alignItems: "center",
    flex: 1,
    borderRadius: ms(12),
    marginBottom: ms(8),
  },
  folderContainer: {
    flex: 1,
    height: ms(60),
    minHeight: ms(60),
    backgroundColor: Colors.text + "10",
    borderRadius: ms(12),
    paddingHorizontal: ms(16),
    flexDirection: "row",
    gap: ms(8),
    alignItems: "center",
  },
  actionsContainer: {
    flexDirection: "row",
    gap: ms(8),
  },
  editButton: {
    justifyContent: "center",
    alignItems: "center",
    width: ms(60),
    height: ms(60),
    borderRadius: ms(12),
    backgroundColor: Colors.text,
  },
  deleteButton: {
    justifyContent: "center",
    alignItems: "center",
    width: ms(60),
    height: ms(60),
    borderRadius: ms(12),
    backgroundColor: Colors.error,
  },
  whiteIcon: {
    tintColor: Colors.white,
  },
  buttonText: {
    fontWeight: "500",
    fontSize: ms(16),
    color: Colors.text,
  },
  negativeMargin: {
    marginBottom: -ms(16),
  },
});

export default AlertWidgetManageFolders;
